// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__23tIQ","head":"Projects_head__1Esuf","projectsGrid":"Projects_projectsGrid__kfLrB"};